import moment from 'moment-timezone';

export default function getDiffDate(timestamp) {
  if (!timestamp) return null;

  const oldStamp = moment(timestamp);
  if (!oldStamp.isValid()) return null;

  const currentStamp = moment();
  const difference = currentStamp.diff(oldStamp, 'minutes');
  return difference;
}
